import { Table, TableColumnsType } from 'antd'
import { useNavigate } from 'react-router-dom'

import { useTablePagination } from 'src/hooks'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { data } from '../data'

export const ReportsTable = () => {
  const { t } = useLocales()
  const navigate = useNavigate()

  const pagination = useTablePagination()

  const columns: TableColumnsType = [
    {
      key: 'title',
      title: t('reports.report_title'),
      dataIndex: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title)
    },
    {
      key: 'report_type',
      width: 270,
      title: t('reports.report_type'),
      dataIndex: 'report_type',
      sorter: (a, b) => a.report_type.localeCompare(b.report_type)
    },
    {
      key: 'department',
      title: t('common.department'),
      dataIndex: 'department',
      sorter: (a, b) => a.department.localeCompare(b.department)
    },
    {
      key: 'date',
      title: t('common.date'),
      dataIndex: 'date',
      sorter: (a, b) => a.date.localeCompare(b.date)
    }
  ]

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      rowClassName="pointer"
      onRow={({ id }) => ({
        onClick: () => navigate(paths.reports.details(String(id)))
      })}
      pagination={{ ...pagination, total: data?.length }}
    />
  )
}
